import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GeneralMasterComponent } from './Masters/general-master/general-master.component';
import { UserMasterComponent } from './Masters/user-master/user-master.component';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { LoginComponent } from './login/login/login.component';
import { SetPasswordComponent } from './login/set-password/set-password.component';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { GenerateNoticeComponent } from './notice/generate-notice/generate-notice.component';
import { NavCaseNoticeComponent } from './notice/nav-case-notice/nav-case-notice.component';

import { AddorgcontactComponent } from './Masters/addorgcontact/addorgcontact.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { AddFactSheetComponent } from './notice/add-fact-sheet/add-fact-sheet.component';
import { AddContactComponent } from './notice/add-contact/add-contact.component';
import { AddFollowupComponent } from './notice/add-followup/add-followup.component';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { NoticeDiaryComponent } from './notice/notice-diary/notice-diary.component';
import { DatePipe } from '@angular/common';
import { ExpenseComponent } from './notice/expense/expense.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ModuleComponent } from './dashboard/module/module.component';
import { AddLibraryComponent } from './dashboard/add-library/add-library.component';
import { ViewExpenseComponent } from './dashboard/view-expense/view-expense.component';
import { ViewDiaryComponent } from './dashboard/view-diary/view-diary.component';
import { ViewLibraryComponent } from './dashboard/view-library/view-library.component';
// kks
import { EcodeComponent } from './dashboard/Ecode/Ecode.component';
// kks
import { AddMastersComponent } from './Masters/add-masters/add-masters.component';
import { TokenInterceptorService } from './token-http-interceptor.service';
import { AddUserMastersComponent } from './Masters/add-user-masters/add-user-masters.component';
import { VieworgcontactComponent } from './Masters/vieworgcontact/vieworgcontact.component';
import { ViewfilterComponent } from './filter/viewfilter/viewfilter.component';
import { CorporateDecisionComponent } from './corporate-decision/corporate-decision.component';
import { NavCorporatedecisionComponent } from './corporate-decision/nav-corporatedecision/nav-corporatedecision.component';
import { ReportListingComponent } from './Report/report-listing/report-listing.component';
import { ColumnSelectionComponent } from './Report/column-selection/column-selection.component';
import { CreateDecisionComponent } from './corporate-decision/create-decision/create-decision.component';
import { CreateNoticecaseComponent } from './notice/create-noticecase/create-noticecase.component';
import { UpdateDiaryComponent } from './notice/update-diary/update-diary.component';
import { fvcComponent } from './notice/fvc/fvc.component';

import { ImportDataComponent } from './dashboard/import-data/import-data.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CompanyMasterComponent } from './Masters/company-master/company-master.component';
import { NavCompanyComponent } from './Masters/nav-company/nav-company.component';
import { MasterPageComponent } from './master-page/master-page.component';
import { MasterPageModule } from './master-page/master-page.module';
import { CommunityProfileComponent } from './community-profile/community-profile.component';
import { EscalationComponent } from './alerts/escalation/escalation.component';
import { NotificationComponent } from './alerts/notification/notification.component';
import { EditorComponent } from './email-editor/editor/editor.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { EvaluationStructureComponent } from './evaluation/evaluation-structure/evaluation-structure.component';
import { NavEvaluationComponent } from './evaluation/nav-evaluation/nav-evaluation.component';
import { EvaluationFormComponent } from './evaluation/evaluation-form/evaluation-form.component';
import { GraphSummaryComponent } from './dashboard/graph-summary/graph-summary.component';
import { BaseChartDirective, ThemeService, } from 'ng2-charts';
import { NotificationV2Component } from './alerts/notification-v2/notification-v2.component';
import { NotificationEntryComponent } from './alerts/notification-entry/notification-entry.component';
import { FeatureEntryComponent } from './alerts/feature-entry/feature-entry.component';
import { EscalationNavComponent } from './alerts/escalation-nav/escalation-nav.component';
import { EscalationUserEntryComponent } from './alerts/escalation-user-entry/escalation-user-entry.component';
import { EscalationReportEntryComponent } from './alerts/escalation-report-entry/escalation-report-entry.component';
import { RolePoliciesComponent } from './role-policy/role-policies/role-policies.component';
import { SystemConfigurationComponent } from './system-configuration/system-configuration.component';
import { CaseTransferComponent } from './notice/case-transfer/case-transfer.component';
import { MyprofileComponent } from './dashboard/myprofile/myprofile.component';
import { CaptionSettingsComponent } from './caption-setting/caption-settings/caption-settings.component';
import { ReportConfigurationComponent } from './Report/report-configuration/report-configuration.component';
import { ReportConfigNavComponent } from './Report/report-config-nav/report-config-nav.component';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

// kks
import { FinalVerdictComponent } from './notice/Final-Verdict/Final-Verdict.component';

import { sharingoptionFormComponent } from './evaluation/sharingoption-form/sharingoption-form.component';
// kks

import { EmailLogComponent } from './alerts/email-log/email-log.component';
// import { AlertComponent } from './alertpopup/_alert/alert.component';
import { AlertModule } from './alertpopup/_alert';
import { ConfirmDialogComponent } from './alertpopup/confirm-dialog/confirm-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TableStateComponent } from './shared/table-state/table-state.component';
import {ToastrModule} from 'ngx-toastr'
import { RowsPerPageComponent } from './shared/rows-per-page/rows-per-page.component';

@Pipe({
  name: 'safe',
  standalone: false
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
@NgModule({
  declarations: [
    AppComponent,
    GeneralMasterComponent,
    UserMasterComponent,
    ForgotPasswordComponent,
    LoginComponent,
    SetPasswordComponent,
    DashboardComponent,
    GenerateNoticeComponent,
    AddorgcontactComponent,
    NavCaseNoticeComponent,
    AddFactSheetComponent,
    AddContactComponent,
    AddFollowupComponent,
    SafePipe,
    NoticeDiaryComponent,
    ExpenseComponent,
    ModuleComponent,
    AddLibraryComponent,
    ViewExpenseComponent,
    ViewDiaryComponent,
    ViewLibraryComponent,
    EcodeComponent,
    AddMastersComponent,
    AddUserMastersComponent,
    VieworgcontactComponent,
    ViewfilterComponent,
    CorporateDecisionComponent,
    NavCorporatedecisionComponent,
    ReportListingComponent,
    CreateDecisionComponent,
    CreateNoticecaseComponent,
    UpdateDiaryComponent,
    fvcComponent,
    ImportDataComponent,
    CreateNoticecaseComponent,
    CompanyMasterComponent,
    NavCompanyComponent,
    ColumnSelectionComponent,
    MasterPageComponent,
    CommunityProfileComponent,
    EscalationComponent,
    NotificationComponent,
    EditorComponent,
    EvaluationStructureComponent,
    NavEvaluationComponent,
    EvaluationFormComponent,
    sharingoptionFormComponent,
    GraphSummaryComponent,
    NotificationV2Component,
    NotificationEntryComponent,
    FeatureEntryComponent,
    EscalationNavComponent,
    EscalationUserEntryComponent,
    EscalationReportEntryComponent,
    RolePoliciesComponent,
    SystemConfigurationComponent,
    CaseTransferComponent,
    MyprofileComponent,
    CaptionSettingsComponent,
    ReportConfigurationComponent,
    ReportConfigNavComponent,
    // NavContactComponent
    ReportConfigNavComponent,
    EmailLogComponent,
    FinalVerdictComponent,
    ConfirmDialogComponent,
    // , AlertComponent
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    NgxPaginationModule,
    MasterPageModule,
    MatIconModule,
    BaseChartDirective,
    AngularEditorModule,
    AlertModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }), 
    TableStateComponent,
    RowsPerPageComponent,
    ToastrModule.forRoot({
      timeOut: 2000,
      preventDuplicates: true,
    }),
  ],
  providers: [provideCharts(withDefaultRegisterables()),
    DatePipe, { provide: LocationStrategy, useClass: PathLocationStrategy },
    ThemeService,
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
  provideHttpClient(withInterceptorsFromDi()),provideAnimations(),],
  exports: [TableStateComponent,RowsPerPageComponent]
})
export class AppModule {
}
